import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '@/assets/icons/arrows/arr-gray-left.svg';
import _imports_1 from '@/assets/icons/arrows/ico-ico-zezarizeni.svg';
const _hoisted_1 = { class: "side-box__header d-flex justify-content-between align-items-center" };
const _hoisted_2 = { class: "atom-back__inner d-flex align-items-center" };
const _hoisted_3 = { class: "side-box__title" };
const _hoisted_4 = {
    key: 0,
    class: "side-box__content"
};
const _hoisted_5 = {
    key: 0,
    class: "messages__suspended font-weight-bold"
};
const _hoisted_6 = { class: "side-box__row d-flex align-items-center mt-3" };
const _hoisted_7 = { class: "side-box__content__label text gray-text" };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = { class: "side-box__row d-flex align-items-center mt-3" };
const _hoisted_10 = { class: "side-box__content__label text gray-text" };
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = { class: "side-box__row d-flex align-items-center mt-3" };
const _hoisted_13 = { class: "side-box__content__label text gray-text" };
const _hoisted_14 = { class: "side-box__content__value ml-3" };
const _hoisted_15 = { class: "side-box__row d-flex align-items-center mt-3" };
const _hoisted_16 = { class: "side-box__content__label text gray-text" };
const _hoisted_17 = { class: "side-box__content__value ml-3" };
const _hoisted_18 = {
    key: 0,
    class: "atom-tag atom-tag--muted"
};
const _hoisted_19 = {
    key: 1,
    class: "atom-tag atom-tag--success"
};
const _hoisted_20 = {
    key: 2,
    class: "atom-tag atom-tag--warning"
};
const _hoisted_21 = { class: "side-box__row d-flex align-items-center mt-3" };
const _hoisted_22 = { class: "side-box__content__label text gray-text" };
const _hoisted_23 = { class: "side-box__content__value ml-3" };
const _hoisted_24 = { class: "side-box__row d-flex align-items-center mt-3" };
const _hoisted_25 = { class: "side-box__content__label text gray-text" };
const _hoisted_26 = {
    key: 0,
    class: "side-box__content__value ml-3"
};
const _hoisted_27 = { class: "side-box__row d-flex align-items-center mt-3" };
const _hoisted_28 = { class: "side-box__content__label text gray-text" };
const _hoisted_29 = {
    key: 0,
    class: "side-box__content__value ml-3"
};
const _hoisted_30 = {
    key: 0,
    class: "border-top mt-4 pt-4"
};
const _hoisted_31 = { class: "d-flex justify-content-between" };
const _hoisted_32 = { class: "text-large" };
const _hoisted_33 = {
    style: { "white-space": "pre-wrap", "overflow": "auto" },
    class: "mt-4"
};
const _hoisted_34 = {
    key: 1,
    class: "justify-content-left border-top mt-4 pt-4 pb-4"
};
const _hoisted_35 = { key: 0 };
const _hoisted_36 = { key: 1 };
const _hoisted_37 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_38 = {
    key: 2,
    class: "d-flex justify-content-left border-top mt-4 pt-4 pb-4"
};
const _hoisted_39 = {
    key: 4,
    class: "border-top pt-4 mesages__timestamps"
};
const _hoisted_40 = {
    id: "deliveries",
    class: "mt-3 mb-3"
};
const _hoisted_41 = {
    key: 5,
    class: "border-top pt-4 mesages__timestamps"
};
const _hoisted_42 = {
    id: "deliveries",
    class: "mt-3"
};
const _hoisted_43 = { class: "d-flex" };
const _hoisted_44 = { class: "messages__timestamps__col gray-text" };
const _hoisted_45 = { class: "messages__timestamps__col gray-text" };
const _hoisted_46 = { class: "messages__timestamps__col gray-text code" };
const _hoisted_47 = { class: "d-flex messages__timestamps__item" };
const _hoisted_48 = ["innerHTML"];
const _hoisted_49 = { class: "messages__timestamps__col" };
const _hoisted_50 = { class: "messages__timestamps__col code" };
const _hoisted_51 = { class: "atom-tag atom-tag--success" };
const _hoisted_52 = ["innerHTML"];
const _hoisted_53 = { class: "messages__timestamps__col" };
const _hoisted_54 = { class: "messages__timestamps__col d-block code" };
const _hoisted_55 = ["title"];
const _hoisted_56 = { key: 1 };
const _hoisted_57 = { class: "error" };
import axios from "axios";
import { client } from "@/main";
import { ref, watch, computed } from "vue";
import { useRoute } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'udpMessageDetail',
    props: {
        isOpen: { type: Boolean },
        message: {},
        device: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const route = useRoute();
        const transformationFunction = ref(null);
        const deliveries = ref([]);
        const loadingDeliveries = ref(false);
        const areDeliveriesLoaded = ref(false);
        const showOriginalMessage = ref(false);
        const deliveriesByTime = computed(() => {
            return deliveries.value.toSorted((a, b) => {
                return new Date(b.messageTime).getTime() - new Date(a.messageTime).getTime();
            });
        });
        function close() {
            deliveries.value = [];
            loadingDeliveries.value = false;
            areDeliveriesLoaded.value = false;
            showOriginalMessage.value = false;
            emits("close");
        }
        async function exportMessages() {
            let response;
            try {
                response = await axios.post(process.env.VUE_APP_APICMS + "/exportMessages?deviceType=udp&format=xlsx", [props.message.message], {
                    responseType: "blob"
                });
            }
            catch (e) {
                console.error(e);
            }
            let d = new Date(new Date(props.message.message.timestamp).getTime() + 2 * 60 * 60 * 1000);
            let dateFrom = d.toISOString();
            const fileNameSuffix = "_" +
                props.device.deviceId +
                "_" +
                dateFrom.replaceAll(":", "_").replaceAll("-", "_").replaceAll(".", "_").replaceAll("Z", "");
            const fileName = "export" + fileNameSuffix + ".xlsx";
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            if (window.navigator.msSaveBlob) {
                // FOR IE BROWSER
                navigator.msSaveBlob(blob, fileName);
            }
            else {
                // FOR OTHER BROWSERS
                const csvUrl = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.setAttribute("href", csvUrl);
                link.setAttribute("download", fileName);
                link.click();
            }
        }
        async function loadTransformationFunction(id) {
            try {
                const response = await client.path("/projects/{id}/transformations/{transformationId}").method("GET").create()({
                    id: route.params.projectId,
                    transformationId: id
                });
                return response.data;
            }
            catch (e) {
                console.error(e);
            }
        }
        watch(() => props.message?.transformationId, async (id) => {
            if (!id || id === transformationFunction.value?.transformationId) {
                return;
            }
            transformationFunction.value = (await loadTransformationFunction(id)).data[0];
        });
        async function loadDeliveries() {
            loadingDeliveries.value = true;
            const loadedDeliveries = [];
            try {
                const response = await client.path("/udp/devices/{id}/up/messages/{messageId}/deliveries").method("GET").create()({
                    id: props.device.deviceId,
                    messageId: props.message.id
                });
                for (const delivery of response.data.data) {
                    let getEndpoint;
                    if (delivery.custDestType === "MQTT") {
                        getEndpoint = await client.path("/mqtt/gateways/{id}").method("GET").create();
                    }
                    else {
                        getEndpoint = await client.path("/http/endpoints/{id}").method("GET").create();
                    }
                    const endpointResponse = await getEndpoint({ id: delivery.custDestId });
                    const endpoint = endpointResponse.data.data.length ? endpointResponse.data.data[0] : endpointResponse.data.data;
                    loadedDeliveries.push({ ...delivery, name: endpoint.custDestName });
                }
            }
            catch (e) {
                console.error(e);
            }
            deliveries.value = loadedDeliveries;
            loadingDeliveries.value = false;
            areDeliveriesLoaded.value = true;
        }
        return (_ctx, _cache) => {
            const _component_AppLoader = _resolveComponent("AppLoader");
            const _component_RouterLink = _resolveComponent("RouterLink");
            const _component_InfoExclamationMarkNoText = _resolveComponent("InfoExclamationMarkNoText");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["side-box", { active: _ctx.isOpen }])
            }, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "side-box__overlay" }, null, -1)),
                _createElementVNode("div", {
                    class: _normalizeClass(["side-box__inner last-active", { opened: _ctx.isOpen }])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: "atom-back atom-back--gray",
                            onClick: close
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("zpet")), 1)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h2", null, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("zpravaZeZarizeni")) + " ", 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.device.name), 1)
                        ])
                    ]),
                    (_ctx.message?.message)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (_ctx.message?.messageStatus === 'suspended')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("MESSAGE_SUSPENDED")), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("datum")), 1),
                                _createElementVNode("span", {
                                    class: "side-box__content__value ml-3",
                                    innerHTML: _ctx.$filters.date(_ctx.message.messageTime)
                                }, null, 8, _hoisted_8)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("RECEIVED_AT")), 1),
                                _createElementVNode("span", {
                                    class: "side-box__content__value ml-3",
                                    innerHTML: _ctx.$filters.time(_ctx.message.messageTime)
                                }, null, 8, _hoisted_11)
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("typZpravy")), 1),
                                _createElementVNode("span", _hoisted_14, [
                                    _createElementVNode("span", null, [
                                        _cache[4] || (_cache[4] = _createElementVNode("img", {
                                            src: _imports_1,
                                            class: "mr-2"
                                        }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t("zeZarizeni")), 1)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("stav")), 1),
                                _createElementVNode("span", _hoisted_17, [
                                    (_ctx.message.messageStatus == 'suspended')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t("MSG_SUSPENDED")), 1))
                                        : (_ctx.message.messageStatus === 'normal')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "OK"))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_20, "?"))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("port")), 1),
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.message.message.port), 1)
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("nazevZarizeni")), 1),
                                (_ctx.device)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.device.name), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("idZarizeniMQTT")), 1),
                                (_ctx.device)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.device.deviceId), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                                (_ctx.message.messageStatus !== 'suspended')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("strong", _hoisted_32, _toDisplayString(_ctx.$t("obsahZpravy")), 1),
                                            _createElementVNode("a", {
                                                onClick: _cache[0] || (_cache[0] = ($event) => (exportMessages('xlsx')))
                                            }, _toDisplayString(_ctx.$t("stahnoutXLS")), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.message.message), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (transformationFunction.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                        _createElementVNode("div", null, [
                                            _createTextVNode(_toDisplayString(_ctx.$t("INFOTEXT_MESSAGES_TRANSFORMATION_PROCESSED")) + ": ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(transformationFunction.value.label), 1)
                                        ]),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("button", {
                                                class: "btn btn-primary",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (showOriginalMessage.value = showOriginalMessage.value ? false : true))
                                            }, [
                                                (!showOriginalMessage.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t("BTN_SHOW_ORIGINAL_MESSAGE")), 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t("BTN_HIDE_ORIGINAL_MESSAGE")), 1))
                                            ]),
                                            (showOriginalMessage.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.message.message_src), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (!areDeliveriesLoaded.value && _ctx.message.messageStatus !== 'suspended')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        _createElementVNode("button", {
                                            class: "btn btn-primary",
                                            onClick: _cache[2] || (_cache[2] = ($event) => (loadDeliveries()))
                                        }, _toDisplayString(_ctx.$t("nacistDeliveries")), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                (loadingDeliveries.value)
                                    ? (_openBlock(), _createBlock(_component_AppLoader, {
                                        key: 3,
                                        id: "deliveriesLoading",
                                        class: "pl-5 pt-2 pb-2"
                                    }))
                                    : _createCommentVNode("", true),
                                (!loadingDeliveries.value && areDeliveriesLoaded.value && deliveries.value.length == 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        _createElementVNode("div", _hoisted_40, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("noDeliveries")), 1)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (!loadingDeliveries.value && areDeliveriesLoaded.value && deliveries.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("datumACas")), 1),
                                                _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("akce")), 1),
                                                _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("stav")), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_47, [
                                                _createElementVNode("span", {
                                                    class: "messages__timestamps__col",
                                                    innerHTML: _ctx.$filters.dateTimeMicro(_ctx.message.messageTime)
                                                }, null, 8, _hoisted_48),
                                                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t("ZpravaOdeslanaZeZarizeni")), 1),
                                                _createElementVNode("span", _hoisted_50, [
                                                    _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t("OK")), 1)
                                                ])
                                            ]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveriesByTime.value, (delivery, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                    key: index + 'd',
                                                    class: "d-flex messages__timestamps__item"
                                                }, [
                                                    _createElementVNode("span", {
                                                        class: "messages__timestamps__col",
                                                        innerHTML: _ctx.$filters.dateTimeMicro(delivery.messageTime)
                                                    }, null, 8, _hoisted_52),
                                                    _createElementVNode("span", _hoisted_53, [
                                                        _createVNode(_component_RouterLink, {
                                                            to: {
                                                                name: delivery.custDestType == 'MQTT' ? 'mqttEndpoint' : 'endpoint',
                                                                params: {
                                                                    id: delivery.custDestId,
                                                                    device: _ctx.device
                                                                }
                                                            }
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t("ZpravaOdeslanaNaEndpoint")) + " \"" + _toDisplayString(delivery.name) + "\" ", 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to"])
                                                    ]),
                                                    _createElementVNode("span", _hoisted_54, [
                                                        (delivery.code >= 200 && delivery.code < 300)
                                                            ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                                                key: 0,
                                                                class: "atom-tag atom-tag--success",
                                                                title: delivery.code + ' ' + delivery.error
                                                            }, [
                                                                _createTextVNode(_toDisplayString(_ctx.$t("OK")), 1)
                                                            ], 8, _hoisted_55)), [
                                                                [_directive_tooltip]
                                                            ])
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_56, [
                                                                _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t("nedoruceno")), 1),
                                                                _createVNode(_component_InfoExclamationMarkNoText, {
                                                                    "info-tooltip": delivery.code + ' ' + delivery.error
                                                                }, null, 8, ["info-tooltip"])
                                                            ]))
                                                    ])
                                                ]));
                                            }), 128))
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ], 2)
            ], 2));
        };
    }
});
